/*!
 * Helper functions for knockout bindings.
 * Copyright 2017, Selerix Systems, Inc. All Rights Reserved
 * This is unpublished proprietary source code of Selerix, Inc. The
 * copyright notice above does not evidence any actual or intended
 * publication of such source code.
 */

// KnockoutJS Bindings
(function (b) {
	'use strict';

	b.prettify = {
		init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
		},
		update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
			var scriptStarter = '<' + '%';
			var scriptStopper = '%' + '>';
			var value = valueAccessor();

			var prefix = '';
			var suffix = '';

			var text = value() || '';

			var containsScript = text.indexOf(scriptStarter) > -1 || text.indexOf(scriptStopper) > -1;

			if (containsScript) {
				prefix = '<pre class="prettyprint linenums">';
				suffix = '</pre>';
			}

			var re = /</gi;
			var re2 = />/gi;
			text = text.replace(re, "&lt;");
			text = text.replace(re2, "&gt;");


			element.innerHTML = prefix + text + suffix;

			if (containsScript) {
				prettyPrint();
			}
		}
	};

	// Smart editors
	b.smartMaskEditor = {
		init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
			if (!$(element)[0].id) $(element).attr('id', selerix.globals.guid());

			var pattern = $(element).attr('data-pattern');
			if (pattern) {
				$(element).after($('<span/>').addClass("warning helpIcon").css("padding", "3px").attr("id", $(element)[0].id + "_warning").css("display", "none").attr("title", "Invalid value"));
				valueAccessor().extend({ pattern: { warning: "#" + $(element)[0].id + "_warning", pattern: pattern } });
			}

			element.proxyEditor = $('<input type="text" id="' + $(element)[0].id + '_editor"></input>');
			element.ControlValue = $('<input type="hidden" id="' + $(element)[0].id + '_controlValue"></input>');
			element.ControlText = $('<input type="hidden" id="' + $(element)[0].id + '_controlText"></input>');
			element.skipUIUpdate = false;

			$(element).after(element.ControlText);
			$(element).after(element.ControlValue);
			$(element).after(element.proxyEditor);

			$.each($(element).prop('attributes'), function () {
				if (this.name != 'id') element.proxyEditor.attr(this.name, this.value);
			});
			$(element).css('display', 'none');

			element.proxyEditor.attr('data-ControlValueID', $(element)[0].id + '_controlValue');
			element.proxyEditor.attr('data-ControlTextID', $(element)[0].id + '_controlText');

			element.proxyEditor.updateObservable = function (value) {
			    if (!ko.isObservable(valueAccessor())) return;
				if (valueAccessor()() != value) {
				    element.skipUIUpdate = true;
					$(element).val(value);
					$(element).trigger('change');
					valueAccessor() (value);
			    }
			}

			var css = $(element).data('securemask') ? 'smartSecureMaskInput' : 'smartMaskEditor';
			CreateEditor(element.proxyEditor, css);
			b.value.init(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext);
		},
		update: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
			var wrappedValue = valueAccessor();
			var value = ko.unwrap(wrappedValue);

			if (typeof (value) !== "undefined" && !element.skipUIUpdate) {
				value = value == null ? '' : value;
				element.proxyEditor[0].set_value(value);
				if (value) element.proxyEditor.removeClass('placeholderMask');
				else element.proxyEditor.addClass('placeholderMask');
			}
			element.skipUIUpdate = false;
			b.value.update(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext);
		}
	};
	b.smartNumericEditor = {
		init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
			var smartControl = 'smartNumericEditor';
			if ($(element).data('bind').indexOf('smartPercentEditor') > -1) smartControl = 'smartPercentEditor';
			else if ($(element).data('bind').indexOf('smartCurrencyEditor') > -1) smartControl = 'smartCurrencyEditor';

			CreateEditor($(element), smartControl);

			b.value.init(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext);
		},
		update: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
			var value = ko.utils.unwrapObservable(valueAccessor());

			if ($(element).isSlxControl()) {
				var slx = $(element).slxControl();
				slx.value(value);
			}

			b.value.update(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext);
		}
	};
	b.smartPercentEditor = b.smartCurrencyEditor = b.smartNumericEditor;
	b.smartDatePicker = {
		init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {			

			element.skipUIUpdate = false;
			element.updateObservable = function (value) {
			    if (!ko.isObservable(valueAccessor())) return;
				if (valueAccessor()() != value) {
					element.skipUIUpdate = true;
					valueAccessor()(value);
				}
		    }

			CreateEditor($(element), "smartDatePicker");
			b.value.init(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext);
		},
		update: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
			var wrappedValue = valueAccessor();
			var value = ko.unwrap(wrappedValue);

			if (value !== void 0 && !element.skipUIUpdate) {
				element.set_value(value);				
			}
			element.skipUIUpdate = false;

			b.value.update(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext);
		}
	};

    // slx controls
	b.slxProgressBar = {
	    init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
	        var options = ko.utils.unwrapObservable(valueAccessor()) || null;
	        if ($(element).slxControl('slxProgressBar') === null) { $(element).slxProgressBar(options); }
	    }
	};
	b.slxValue = {
	    init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
			ko.utils.registerEventHandler(element, 'change.slxKnockout', function () {
	            var value = valueAccessor();
	            if (!$(element).isSlxControl()) {
	                value($(element).val());
	                return;
	            }
	            var slx = $(element).slxControl();
	            value(slx.value());
	            if (value.required && value.required()) { value.validate(); }
	        });
	    },
		update: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
	        var value = ko.utils.unwrapObservable(valueAccessor());
	        if (!$(element).isSlxControl()) { $(element).attr('data-value', value); return; }
	        var slx = $(element).slxControl();
	        slx.value(value);
	    }
	};
	b.slxNumberValue = {
		init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
			var el = $(element);
			if (!el.isSlxControl()) {
				el.slxNumericInput();
			}

			ko.utils.registerEventHandler(element, 'change.slxKnockout', function () {
				var value = valueAccessor();
				if (!el.isSlxControl()) {
					value(el.val());
					return;
				}
				var slx = el.slxControl();
				if (typeof slx.numberValue === 'function') {
					value(slx.numberValue());
				} else {
					value(slx.value());
                }
				if (value.required && value.required()) { value.validate(); }
			});
		},
		update: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
			var value = ko.utils.unwrapObservable(valueAccessor());
			if (!$(element).isSlxControl()) { $(element).attr('data-value', value); return; }
			var slx = $(element).slxControl();
			slx.value(value);
		}
	};
	b.slxText = {
	    init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
			ko.utils.registerEventHandler(element, 'change.slxKnockout', function () {
	            var value = valueAccessor();
	            if (!$(element).isSlxControl()) {
	                value($(element).text());
	                return;
	            }
	            var slx = $(element).slxControl();
	            value(slx.text());
	        });
	    },
		update: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
	        var value = ko.utils.unwrapObservable(valueAccessor());
	        if (!$(element).isSlxControl()) {
	            $(element).attr('value', value);
	            return;
	        }
	        var slx = $(element).slxControl();
	        slx.text(value);
	    }
	};
	b.uniqueId = {
		init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
			ko.utils.registerEventHandler(element, 'change.slxKnockout', function () {
				var value = valueAccessor();
				if (!$(element).isSlxControl()) {
					value($(element).val());
					return;
				}
				setTimeout(function () {
					var slx = $(element).slxControl();
					var id = slx.selectedItem() ? slx.selectedItem().UniqueId : '';
					value(id);
				}, 300);
			});
		}
	}

	// money text display
	b.money = {
		format: function (amount) {
			var a = (ko.isComputed(amount)) ? amount() : amount;
			if (isNaN(a)) a = (a.indexOf('$') > -1) ? a.substring(a.lastIndexOf('$')) : a;
			var round = Math.pow(10, 2), num = isNaN(a) ? 0 : parseFloat(+a),
				val = Math.round(num * round) / round;
			return val.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
		},
		init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
			var amount = b.money.format(valueAccessor()).toString();
			ko.applyBindingsToNode(element, { text: amount });
		},
		update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
			var amount = b.money.format(valueAccessor()).toString();
			ko.applyBindingsToNode(element, { text: amount });
		}
	};

	// confirm binding
	b.confirm = {
		'init': function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
			var originalValue = valueAccessor();
			var newValueAccesssor = function () {
			    return function () {
			        if (typeof originalValue === 'function') {
			            createDialog($(element).attr("data-confirm"), function (confirmed) {
			                if (confirmed) {
			                    originalValue.apply(viewModel, arguments);
			                }
			            });
			        }
			        else if (originalValue.hasOwnProperty('templateID')) {
			            var t = $($('#' + originalValue.templateID).html());
			            var tID = t.attr('id');
			            $('#' + tID).remove();
			            $('body').prepend(t);
			            t.find('[data-toggle="tooltip"]').tooltip();
			            ko.applyBindingsToDescendants(bindingContext, t[0]);
			            createDialog({ customID: tID });
			        }
			        else if (originalValue.hasOwnProperty('customID')) {
			            createDialog(originalValue);
			        }
				}
			}
			b.click.init(element, newValueAccesssor, allBindingsAccessor, viewModel, bindingContext);
		}
	}

	// boolean value binding
	b.booleanValue = {
		init: function (element, valueAccessor, allBindingsAccessor) {
			var observable = valueAccessor();
			var interceptor = ko.computed({
				read: function () {
					return observable().toString();
				},
				write: function (newValue) {
					observable(newValue === "true");
				}
			});

			ko.applyBindingsToNode(element, { value: interceptor });
		}
	};

	// tooltip binding
	b.tooltip = {
		init: function (element, valueAccessor, allBindingsAccessor) {
			if (valueAccessor()) {
				$(element).attr("title", valueAccessor());
				$(element).tooltip();
			}
		}
	};

	// on enter binding
	b.onEnter = {
		init: function (element, valueAccessor, allBindings, viewModel) {
		    var callback = valueAccessor();
			$(element).keypress(function (event) {
				var keyCode = (event.which ? event.which : event.keyCode);
				if (keyCode === 13) {
					if (element.onChangeInterval) {
						clearInterval(element.onChangeInterval);
						element.onChangeInterval = null;
					}
					callback.call(viewModel);
					return false;
				}
				return true;
			});
		}
	};

	// on delay binding
	b.onDelay = {
		init: function (element, valueAccessor, allBindings, viewModel) {
		    element.onChangeInterval = null;

		    var value = valueAccessor(), delay = 45, callback = value, assert;
		    if (typeof(value) !== 'function') {
		        callback = value.callback;
		        if (value.delay === 0) { delay = 1; }
		        else { delay = !isNaN(value.delay) && value.delay > 0 ? value.delay / 10 : delay; }
		        assert = value.assert;
		    }

			var timer = delay;
			$(element).data('previous-value', $(element).val());
			$(element).on('input', function (event) {
			    var element = this, el = $(this);
			    if (typeof (assert) === 'function' && !assert.call(element)) {
			        timer = delay;
			        clearInterval(element.onChangeInterval);
			        element.onChangeInterval = null;
			        return false;
			    }

				if (element.onChangeInterval === null) {
					element.onChangeInterval = setInterval(function () {
						if (timer === 0) {
							clearInterval(element.onChangeInterval);
							element.onChangeInterval = null;

							if (el.data('previous-value') === el.val()) { return; }
							else { el.data('previous-value', el.val()); }

							callback.call(viewModel);
						} else timer--;
					}, 10);
				}
				timer = delay;
				return true;
			});
		}
	}

    // qr code
	b.QRCode = {
	    init: function (element, valueAccessor) {
	        MakeQRCode(element, ko.unwrap(valueAccessor()));
	    }
	};

	b.ckEditor = {
	    init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
            if (!$(element)[0].id) $(element).attr('id', 'ckEditor' + selerix.globals.guid());
            var txtBoxID = $(element).attr('id');
            var options = allBindingsAccessor().ckEditorOptions || {};

	        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
	            if (CKEDITOR.instances[txtBoxID]) {
	                CKEDITOR.remove(CKEDITOR.instances[txtBoxID]);
	            }
	        });

	        $(element).ckeditor(options);

	        CKEDITOR.instances[txtBoxID].focusManager.blur = function () {
	            var observable = valueAccessor();
	            observable($(element).val());
	        };
	    },
	    update: function (element, valueAccessor, allBindingsAccessor, viewModel) {
	        var val = ko.utils.unwrapObservable(valueAccessor());
	        $(element).val(val);
	    }
	};
})(ko.bindingHandlers);

// JQWidget Bindings
try {
	(function (jqx) {
		ko.jqwidgets = ko.jqwidgets || {};
		ko.jqwidgets.knockout = function (settings) {
			var self = this, handler = { name: settings.name };
			handler.init = function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
				var target = ko.utils.unwrapObservable(valueAccessor());
				var obj = ko.toJS(target);
				if (settings.reset) { settings.reset() }
				if (jqx.data(element)[settings.name] === void 0) {
					var arr = []; jqx(element)[settings.name]();
					widget = jqx.data(element)[settings.name].instance;
					jqx.each(settings, function (P, Q) {
						if (widget.hasOwnProperty(P) && obj.hasOwnProperty(P)) {
							if (!widget.koupdating) {
								widget.koupdatingFromObservable = true;
								try {
									var R = false;
									if (settings.serialize) {
										if (settings.serialize(widget, P)) {
											if (ko.toJSON(obj[P]) != ko.toJSON(settings.serialize(widget, P))) { settings.setProperty(widget, P, widget[P], obj[P]) }
											R = true;
										}
									}
									if (!R) { if (ko.toJSON(obj[P]) != ko.toJSON(widget[P])) { settings.setProperty(widget, P, widget[P], obj[P]) } }
								} catch (O) { settings.setProperty(widget, P, widget[P], obj[P]) }
								arr[P] = P;
								widget.koupdatingFromObservable = false
							}
						}
					});
					var copy = {};
					jqx.each(obj, function (P1, P2) { if (arr[P1] === void 0) { copy[P1] = obj[P1] } });
					widget.host[settings.name](copy);
				}
				widget = jqx.data(element)[settings.name].instance;
				widget.koupdatingFromObservable = false;
				widget.koupdating = false;
				if (settings.events) {
					jqx.each(settings.events, function () {
						var evt = this;
						jqx(element).on(evt + "." + element.id,
							function (Q) {
								widget = jqx.data(element)[settings.name].instance;
								if (!widget.koupdatingFromObservable) {
									var P = widget; P.koupdating = true;
									var S = valueAccessor();
									var R = settings.getProperty(widget, Q, evt, target);
									if (R != undefined) {
										if (S.hasOwnProperty(R.name) && jqx.isFunction(S[R.name])) {
											if (ko.isObservable(S[R.name]) && S[R.name].push) { valueAccessor(R.value) } else { S[R.name](R.value) }
										} else { if (S[R.name]) { valueAccessor(R.value) } }
									}
									P.koupdating = false
								}
							}
						)
					})
				}
			};
			handler.update = function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
				var target = ko.utils.unwrapObservable(valueAccessor());
				var obj = ko.toJS(target);
				widget = jqx.data(element)[settings.name].instance;
				if (widget.koupdating) { return; }
				jqx.each(settings, function (K, V) {
					if (widget.hasOwnProperty(K) && obj.hasOwnProperty(K)) {
						if (!widget.koupdating) {
							widget.koupdatingFromObservable = true, P = false;
							if (settings.serialize) {
								if (settings.serialize(widget, K)) {
									if (ko.toJSON(obj[K]) != ko.toJSON(settings.serialize(widget, K))) { settings.setProperty(widget, K, widget[K], obj[K]) }
									P = true;
								}
							}
							if (!P) { if (ko.toJSON(obj[K]) != ko.toJSON(widget[K])) { settings.setProperty(widget, K, widget[K], obj[K]) } }
							widget.koupdatingFromObservable = false
						}
					}
				});
			}
			ko.bindingHandlers[settings.name] = handler;
		};
		var q = new ko.jqwidgets.knockout({
			name: "jqxDateTimeInput", value: null, disabled: false,
			reset: function () { this.value = null; this.disabled = false; },
			events: ["valueChanged"],
			getProperty: function (widget, event, type) {
				if (type == "valueChanged") {
					var format = widget.host.attr('data-dateDisplayFormat') || 'MM/dd/yyyy';
					var val = widget.host[0].get_value();
					if (val !== null && (format !== void 0 || format !== null)) val = { name: "value", value: val.toString(format) };
					else val = { name: "value", value: val };
					return val;
				}
			},
			setProperty: function (widget, key, before, after) {
				if (after === void 0) return;
				if (key === "value") {
					if (after === "") after = null;
					else if (typeof (after) === "string") after = new Date(after);
					widget.host[0].set_value(after);
				}
				if (key === "disabled") { widget.host.jqxMaskedInput({ disabled: true }) };
			}
		});
	})(jqxBaseFramework);
} catch (error) { console.log(error); };

// KnockoutJS Utils
(function (u) {
	'use strict';

	// polyfill to add makeObservable function to utils
	u.makeObservable = function (model, data) {
	    var arr = [];
	    var isArray = Array.isArray(data);
		if (!isArray) {
			arr.push(data);
			data = arr, arr = [];
		}
		for (var d = 0; d < data.length; d++) {
		    var obj = $.extend({}, data[d]);

			for (var m in model) {
			    if (ko.isObservable(model[m])) {
					if (!ko.isObservable(obj[m])) {
					    if (model[m].destroyAll === void 0 && !Array.isArray(model[m]())) {
					        obj[m] = ko.observable(obj[m]);
					        if (model[m].extended !== void 0) {
					            for (var x in model[m].extended) {
					                var val = model[m].extended[x], ext = {};
					                ext[x] = val;
					                obj[m].extend(ext);
					            }
					        }
					        if (model[m].required === void 0) obj[m].required = ko.observable(false);
					    }
					    else {
					        if (model[m].extended !== void 0 && model[m].extended.makeObservable !== void 0) {
					            obj[m] = u.makeObservable(model[m].extended.makeObservable, obj[m]);
					        }
					        obj[m] = ko.observableArray(obj[m]);
					    }
					}
				}
			}
			arr.push(obj);
		}
		return !isArray ? arr[0] : arr;
	};

	// polyfill to extend array for computed observables
	u.extendArray = function (array, extObj) {
		var arr = [];
		$.each(array, function (key, obj) {
			arr.push($.extend(obj, cloneObservables(extObj)));
		});
		return arr;

		// resolves closure issue
		function cloneObservables(obj) {
			var retObj = {};
			for (var key in obj) {
				if (obj.hasOwnProperty(key)) {
					if (ko.isObservable(obj[key]))
						if (!(obj[key].destroyAll === void 0)) retObj[key] = ko.observableArray();
						else retObj[key] = ko.observable();
				}
			}
			return retObj;
		}
	}
})(ko.utils);

// KnockoutJS Functions
(function (f) {
	'use strict';

	f.bypassable = function () {
		this.notifySubscribers = function () {
			if (!this.bypass) {
				ko.subscribable.fn.notifySubscribers.apply(this, arguments);
			}
		};
		this.withBypass = function (newvalue) {
			this.bypass = true;
			this(newvalue);
			this.bypass = false;
		}
		return this;
	};
})(ko.observable.fn);

//new function ($) {
//	$.fn.setCursorPosition = function (pos) {
//		if (this.setSelectionRange) {
//			this.setSelectionRange(pos, pos);
//		} else if (this.createTextRange) {
//			var range = this.createTextRange();
//			range.collapse(true);
//			if (pos < 0) {
//				pos = $(this).val().length + pos;
//			}
//			range.moveEnd('character', pos);
//			range.moveStart('character', pos);
//			range.select();
//		}
//	}
//}(jQuery);